import { useEffect } from 'react';
// routes
import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';
// hooks
import { useRootRedirectReadiness } from 'src/auth/hooks/use-app-readiness';
// components
import { SplashScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

export default function SmartRootRedirect() {
  const router = useRouter();

  const { state, redirectTo } = useRootRedirectReadiness();

  useEffect(() => {
    // Don't redirect if we're on an installation route - these should be accessible without auth
    const currentPath = window.location.pathname;
    if (currentPath.startsWith('/installation/')) {
      return;
    }

    // Handle redirection based on app readiness state
    if (redirectTo) {
      router.replace(redirectTo);
    } else if (state === 'ready') {
      // All checks passed - redirect to dashboard
      router.replace(paths.dailyOverview.root);
    }
  }, [state, redirectTo, router]);

  // Don't render anything if we're on an installation route - these should be accessible without auth
  const currentPath = window.location.pathname;
  if (currentPath.startsWith('/installation/')) {
    return null;
  }

  // Show splash screen while evaluating
  return <SplashScreen />;
}
